var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-logo-container"},[_c('div',{staticClass:"navbar-logo-link"},[_c('div',{staticClass:"itms-logo-bg-out"},[_c('div',{staticClass:"itms-logo-bg"}),_c('div',{staticClass:"gray-line"}),_c('div',{staticClass:"itms-system-name",attrs:{"translate":"no"}},[_vm._v("iTMS")])])])])
}]

export { render, staticRenderFns }